<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    title: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'base'
    },
    active: {
      type: String,
      required: true
    }
  },
  methods: {
    onClick(type) {
      this.$emit('click', type)
    },
    toUpperCasefirst(str) {
      const strarr = str.split(' ');
      let result = '';

      for(let i in strarr) {
        result  = `${strarr[i].substring(0,1).toUpperCase()}${strarr[i].substring(1)}`;
      }

      return result;
    }
  }
}
</script>
<template>
  <el-dropdown
    :class="[`isStyle${toUpperCasefirst(type)}`, $style.baseDropdownMenu]"
    trigger="click"
    hide-on-click
    @command="onClick"
  >
    <div class="toggle py-md-3 py-2 md:text-lg text-base d-flex align-items-center justify-content-between">
      {{ title }}
      <i class="el-input__icon el-icon-arrow-down"></i>
    </div>
    <el-dropdown-menu slot="dropdown" class="isStyleDropdown" :class="{ isEn: $route.params.lang === 'en' }">
      <el-dropdown-item
        v-for="(item, $index) in list"
        :key="$index"
        :command="item.alias"
        :class="{ 'isActive': item.alias === active }"
      >
        {{ item.title }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>
<style lang="scss" module>
  .baseDropdownMenu {
    :global {
      .toggle {
        position: relative;
        padding: 0 1rem 0 1rem;
        border: 1px solid $color-line;
        // &::before {
        //   position: absolute;
        //   top: 50%;
        //   right: 1rem;
        //   font-family: 'icomoon';
        //   content: '\E803';
        //   transform: translateY(-50%) rotate(0.5turn);
        // }
      }
    }
  }
</style>
